/**
 * Active/default brief type UUID (v2 alignment brief).
 * Must match backend config active_brief_type_uuid so guest and new briefs use the same questions.
 */
export const ACTIVE_BRIEF_TYPE_UUID = '10ff85bf-db10-4913-94a9-ef58774b7742';
